export default {"src":"/_next/static/media/icon-arrow-right-circle.acdc44bd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};